import { FC } from 'react';
import { CircularProgress, TablePagination, Box, Alert } from '@mui/material';
import PageContainer from 'components/PageContainer';
import useOutstandingPayments from 'hooks/data/paymentExpectation/useOutstandingPayments';
import { useFilters, usePagination } from 'further-ui/hooks';
import PaymentExpectationRow from './PaymentExpectationRow';
import BulkPaymentAssignmentFilters from './Filters';
import PageContent from 'components/PageContent';
import { useGetRole } from 'hooks/ui/useGetRole';
import { InvestmentPaymentStatus } from 'further-types/investment';

const breadcrumbs = [
  { label: 'Dashboard', link: '/' },
  { label: 'Bulk payment assignment', isActive: true },
];

const BulkPaymentAssignment: FC = () => {
  const { firmId } = useGetRole();

  const pagination = usePagination({
    id: 'bulk-payment-assignment',
  });

  const { filters, handleChangeFilters } = useFilters(
    'bulk-payment-assignment',
    {
      defaultFilters: {
        firmId,
        paymentStatuses: [
          InvestmentPaymentStatus.NoPayment,
          InvestmentPaymentStatus.PartiallyFunded,
        ],
      },
      onFiltersChange: pagination.toFirstPage,
    },
  );
  const { data, isFetching } = useOutstandingPayments({
    page: pagination.page,
    rowsPerPage: pagination.rowsPerPage,
    ...filters,
  });

  return (
    <PageContainer heading="Bulk payment assignment" breadcrumbs={breadcrumbs}>
      <PageContent>
        <BulkPaymentAssignmentFilters
          filters={filters}
          onFiltersChange={handleChangeFilters}
        />
        {isFetching && <CircularProgress />}
        {!isFetching && (
          <Box gap={4} display="flex" flexDirection="column">
            {(data?.payments ?? []).map((payment) => (
              <PaymentExpectationRow key={payment._id} payment={payment} />
            ))}
          </Box>
        )}
        {!isFetching && data?.payments?.length === 0 && (
          <Alert severity="info">No outstanding payments found</Alert>
        )}
        <TablePagination
          color="primary"
          component="div"
          count={data?.total ?? 0}
          page={pagination.page === 0 ? 0 : pagination.page - 1}
          onPageChange={pagination.handleChangePage}
          rowsPerPage={pagination.rowsPerPage}
          onRowsPerPageChange={pagination.handleChangeRowsPerPage}
        />
      </PageContent>
    </PageContainer>
  );
};

export default BulkPaymentAssignment;
